<template>
  <base-section id="under-maintenance">
    <base-img
      :src="require('@/assets/under-maintenance.png')"
      class="mx-auto"
      contain
      height="550"
      width="450"
    />

    <div class="text-center">
      <base-btn :to="{ name: 'beranda' }">
        Kembali Ke Beranda
      </base-btn>
    </div>
  </base-section>
</template>

<script>
export default {
  name: "SectionUnderMaintenance",
  provide: {
    heading: { align: "center" }
  }
};
</script>
